import { Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { GoPloof } from "../components/organisms/GoPloof";
import activites from "../components/utils/Activities"; // ✅ on importe les données
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";
import { HeroInnerIframe } from "../stories/organisms/HeroInnerIframe";

export default function Activites() {
    const arianeItem = [
        ["/", "Vital'Eau"],
        ["/activites", "Nos activités"],
    ];

    // 🧩 Récupère uniquement les catégories (y compris bébé)
    const categories = activites.filter((a) => a.isCategory);

    return (
        <>
            <MetaMaster title="Vital'eau - Activités" />
            <HeroInnerIframe
                arianeItem={arianeItem}
                video={
                    "https://player.vimeo.com/progressive_redirect/playback/572113130/rendition/1080p/file.mp4?loc=external&log_user=0&signature=2aa7946c774b5f2b9a3819dced934f7f8d1f672aa714821fccb0b41f9f0c4c25"
                }
            />

            <section className="section-show-pool-home" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container justifyContent="center">
                        <Grid item lg={8} md={8} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Nos activités">
                                    Nos activités
                                </h1>
                                <br />
                                <br />
                                <p className="text-center">
                                    Pour les petits, pour les grands, pour tous les profils et toutes les envies ! Chez Vital’Eau, nous proposons un
                                    large choix d’activités aquatiques. Que vous cherchiez à entretenir votre forme, à vous dépenser sans prise de
                                    tête ou à dépasser vos limites, il y a forcément une activité faite pour vous !
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>

            <section className="section-activite-categorie-list">
                <Container maxWidth="xl">
                    <Grid container spacing={4}>
                        {categories.map((cat) => (
                            <Grid item xs={12} sm={6} md={3} lg={3} key={cat.slug}>
                                <Link
                                    key={cat.slug}
                                    href={
                                        cat.redirectToActivity
                                            ? "/activites/bebes-nageurs" // 🍼 cas spécial bébé
                                            : `/activites/${cat.slug}` // enfants / adultes / séniors
                                    }
                                    className="carte-liste-activite"
                                    style={{
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "cover",
                                        backgroundImage: `url(${cat.miniature})`,
                                        backgroundPosition: "center",
                                    }}
                                >
                                    <div>
                                        <h3>{cat.titre}</h3>
                                        <span>Découvrir</span>
                                    </div>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </section>

            <GoPloof />

            <section className="section-contact">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Des questions ?">
                                    Des questions ?
                                </h2>
                                <p className="text-center">
                                    Besoin d’informations ? Envie d’en savoir plus sur nos activités et notre fonctionnement ? <br />
                                    Nous sommes disponibles pour répondre à toutes vos demandes !
                                </p>
                                <br />
                                <Button label="Nous contacter" style={{ width: "fit-content", margin: "0 auto" }} primary href="/contact" />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
